import {defineAsyncComponent} from 'vue'
const CpesRouter = [
  {
    path: 'cpeAccounts',
    name: 'CpeAccounts',
    component: () => import('@/views/Cpes/CpeAccounts/Index.vue'),
  },
  {
    path: 'cpeMaterials',
    name: 'CpeMaterials',
    component: () => import('@/views/Cpes/CpeMaterials/Index.vue'),
  },
  {
    path: 'cpeWorks',
    name: 'CpeWorks',
    component: () => import('@/views/Cpes/CpeWorks/Index.vue'),
  },
  // CPE作品数据
  {
    path: 'cpeWorkDatas',
    name: 'CpeWorkDatas',
    component: () => import('@/views/Cpes/CpeWorkDatas/Index.vue'),
    meta: {
      key: 'stats'
    },
  },
  {
    path: 'cpeCredentials',
    name: 'CpeCredentials',
    component: () => import('@/views/Cpes/CpeCredentials/Index.vue'),
    meta: {
      key: 'stats'
    },
  },
]
export {CpesRouter}
